module.exports = __webpack_public_path__ + "static/media/thanks_img_mobile.109a5ee4.png";